import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, title, light = false }) => (
  <Reveal>
    <div className={`flex items-baseline gap-4 mb-4 ${light ? "text-cream" : "text-choco"}`}>
      <span className="text-xs tracking-[0.3em] uppercase font-bold text-cobalt">{num}</span>
      <span className={`h-px w-16 ${light ? "bg-cream/30" : "bg-choco/30"}`} />
      <span className={`text-xs tracking-[0.3em] uppercase font-bold ${light ? "text-cream/60" : "text-cocoa"}`}>
        {title}
      </span>
    </div>
  </Reveal>
);

export const SectionTitle = ({ children, light = false, className = "" }) => (
  <Reveal delay={0.08}>
    <h2
      className={`font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] ${
        light ? "text-cream" : "text-choco"
      } ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);

export const Section = ({ id, num, chapter, title, children, dark = false, blue = false, className = "" }) => (
  <section
    id={id}
    data-testid={`section-${id}`}
    className={`relative overflow-hidden ${
      dark ? "bg-choco text-cream" : blue ? "bg-powder/40 text-choco" : "bg-cream text-choco"
    } ${className}`}
  >
    <div className="max-w-7xl mx-auto px-6 py-24 md:py-32">
      <Chapter num={num} title={chapter} light={dark} />
      {title && <SectionTitle light={dark}>{title}</SectionTitle>}
      {children}
    </div>
  </section>
);
